import {UILobbyController} from '../../../shared/scripts/ui_html/lobby/UILobbyController'
import {UIRoomController} from './room/UIRoomController'
import {UISceneController} from './UISceneController'
import {Scene} from './UISceneTypes'
import {UIWAdController} from '../ui_ad/UIWAdController'
import {UIUrlController} from '../../../shared/scripts/ui_html/UIUrlController'
import {UIMatchmakingFindGameController} from '../ui_matchmaking/UIMatchmakingFindGameController'
import {UIVLIController} from '../../../shared/scripts/ui_ad/UIVLIController'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'
import {UIWManagerEvents} from './UIWManagerEvents'
import {UIDManagerEvents} from './UIDManagerEvents'
import {UIDiscordSceneController} from '../discord/content_frame/scenes/UIDiscordSceneController'
import {UIMinimalHeaderController} from './new_layout/UIMinimalHeaderController'
import {UISidebarController} from './new_layout/UISidebarController'
import {UIModeSelectorController} from '../../../shared/scripts/ui_html/home_page/UIModeSelectorController'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'
import {UILandingPageController} from './landing_page/UILandingPageController'
import {UILanguageController} from '../ui_language/UILanguageController'
import {UIWFooterController} from './UIWFooterController'
import {UIHeaderProfileController} from './header/UIHeaderProfileController'
import {UIWModeSelectorDetailsController} from './home_page/UIWModeSelectorDetailsController'
import {ClientUserState} from '../../../shared/scripts/ClientUserState'

export class UIManager {
    uiManagerEvents: UIWManagerEvents
    minimalHeader: UIMinimalHeaderController
    sidebar: UISidebarController
    footer: UIWFooterController
    homepageSceneContainer: HTMLDivElement
    newLayoutContainer: HTMLDivElement
    newLayoutContentWithAds: HTMLDivElement
    headerProfile: UIHeaderProfileController

    lobby: UILobbyController
    room: UIRoomController
    sceneController: UISceneController
    adController: UIWAdController
    urlController: UIUrlController
    matchmakingController: UIMatchmakingFindGameController
    vliController: UIVLIController | undefined
    discordSceneController: UIDiscordSceneController | undefined
    landingPage: UILandingPageController
    modeSelectorDetails: UIWModeSelectorDetailsController
    modeSelector: UIModeSelectorController

    constructor() {
        this.uiManagerEvents = UIUtilsEjsVariables.isUserOnDiscord ? new UIDManagerEvents(this) : new UIWManagerEvents(this)
        this.minimalHeader = new UIMinimalHeaderController()
        this.sidebar = new UISidebarController()
        this.footer = new UIWFooterController()
        this.headerProfile = this.minimalHeader.headerProfileController

        this.homepageSceneContainer = document.getElementById('homepage-mode-selector-container') as HTMLDivElement
        this.newLayoutContainer = document.getElementById('new-layout-container') as HTMLDivElement
        this.newLayoutContentWithAds = document.getElementById('new-layout-content-with-ads') as HTMLDivElement

        this.lobby = new UILobbyController()
        this.room = new UIRoomController(this)
        this.adController = new UIWAdController()
        this.urlController = new UIUrlController()
        this.matchmakingController = new UIMatchmakingFindGameController(this)
        this.vliController = UIUtilsEjsVariables.isUserOnDiscord ? undefined : new UIVLIController()
        this.discordSceneController = UIUtilsEjsVariables.isUserOnDiscord ? new UIDiscordSceneController(this.sidebar) : undefined
        this.landingPage = new UILandingPageController(this)
        this.sceneController = new UISceneController(this)

        const onEnterMatchmaking = async(matchType: MatchmakingMatchTypes) => {
            await ClientUserState.requireUser()
            this.matchmakingController.sendFindGameMessageToServer(matchType)
        }

        this.modeSelectorDetails = new UIWModeSelectorDetailsController(onEnterMatchmaking)
        new UILanguageController()

        this.modeSelector = new UIModeSelectorController(Date.now(),
            onEnterMatchmaking,
            (matchType) => {
                this.modeSelectorDetails.show(matchType)
            })

        this.sidebar.setSceneNavigationCallback((scene) => {
            switch(scene) {
                case 'lobby':
                    this.sceneController.loadScene(Scene.Lobby)
                    return
                case 'play':
                    this.sceneController.loadScene(Scene.MainPage)
                    return
            }
        })

        this.sidebar.setLogoClickCallback(() => {
            const sceneToLoad = UISceneController.shouldShowLandingPage() ? Scene.LandingPage : Scene.MainPage
            this.sceneController.loadScene(sceneToLoad)
        })

        this.minimalHeader.setLogoClickCallback(() => {
            const sceneToLoad = UISceneController.shouldShowLandingPage() ? Scene.LandingPage : Scene.MainPage
            this.sceneController.loadScene(sceneToLoad)
        })
    }

    init() {
        this.matchmakingController.init()
    }

    // eslint-disable-next-line class-methods-use-this
    clearDOM() {
        const mainContainer = document.getElementById('main_container')
        if(mainContainer != undefined) mainContainer.remove()
    }
}
